import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { ListItem } from "@website/ui/list-item";
import { Transition } from "@website/ui/transition";
import { getChannel } from "@website/utils/channel/get-channel";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { useToggle } from "@website/utils/use-toggle/useToggle";
import LOGO from "@website/widget/header/assets/logo.png";
import LOGO_SNAPP from "@website/widget/header/assets/logo_snapp.svg";
import { useEffect, useState } from "react";
import { SNAPP_IR_LIST } from "../../hooks/constants";
const alt_logo = replaceSnappTripBasedOnChannel("snapptrip");
export function SnappIrTravelServicesMobileDrawer() {
  const $ = _c(20);
  const [drawerIsOpen, toggleDrawer] = useToggle(false);
  const [selectedService, setSelectedService] = useState(null);
  let t0;
  if ($[0] !== toggleDrawer) {
    t0 = () => {
      setSelectedService(null);
      toggleDrawer();
    };
    $[0] = toggleDrawer;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const openDrawer = t0;
  let t1;
  if ($[2] !== drawerIsOpen || $[3] !== toggleDrawer) {
    t1 = () => {
      setSelectedService(null);
      if (drawerIsOpen) {
        toggleDrawer();
      }
    };
    $[2] = drawerIsOpen;
    $[3] = toggleDrawer;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const closeDrawer = t1;
  let t2;
  let t3;
  if ($[5] !== drawerIsOpen) {
    t2 = () => {
      if (drawerIsOpen) {
        document.body.classList.add("prevent-scroll");
        return _temp;
      }
    };
    t3 = [drawerIsOpen];
    $[5] = drawerIsOpen;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MaterialIcon name="menu" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== openDrawer) {
    t5 = <Button EndIcon={t4} aria-label="open menu" className="lg:!hidden" color="neutral" equalDimension={true} onClick={openDrawer} size="small" variant="text" />;
    $[9] = openDrawer;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== closeDrawer || $[12] !== selectedService) {
    t6 = state => <div className={`bg-on-color-high-emphasis fixed right-0 top-0 z-50 h-full w-0 overflow-y-auto overflow-x-hidden transition-all ease-in-out ${state === "entering" || state === "entered" ? "w-full" : "pointer-events-none"}`}><div className="flex h-16 flex-row items-center gap-2 px-4"><Button EndIcon={<MaterialIcon name="arrow_forward" variant="outlined" />} aria-label="close" color="neutral" equalDimension={true} onClick={closeDrawer} size="small" variant="text" /><div className="flex flex-1 items-center justify-start"><a aria-label={alt_logo} href="/" itemScope={true}><LazyImage alt={`${alt_logo} logo`} height={78} loading="eager" src={getChannel() === "snapp-ir" ? LOGO_SNAPP.src : LOGO.src} title={replaceSnappTripBasedOnChannel("\u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E")} width={137} className="h-8 w-auto" /></a></div></div><nav className="divide-outline-thin divide-y">{SNAPP_IR_LIST.map(item => <a className="flex" href={item.url} key={item.title} onClick={event => {
          if (item.subLinks) {
            event.preventDefault();
            setSelectedService(item);
          }
        }}><ListItem EndIcon={item.subLinks && <MaterialIcon name="chevron_left" variant="outlined" />} data-noindex="true" title={item.title} /></a>)}</nav><div aria-hidden={!selectedService} aria-label={selectedService?.title ?? "\u062E\u062F\u0645\u0627\u062A \u0633\u0641\u0631"} aria-modal="true" className={`bg-on-color-high-emphasis absolute inset-0 z-10 overflow-y-auto ${selectedService ? "pointer-events-auto visible" : "pointer-events-none invisible"}`} role="dialog"><div className="flex h-16 items-center gap-2 px-4"><Button EndIcon={<MaterialIcon name="arrow_forward" variant="outlined" />} aria-label="back to travel services" color="neutral" equalDimension={true} onClick={() => setSelectedService(null)} size="small" variant="text" /><div className="text-button text-center">{selectedService?.title ?? "\u062E\u062F\u0645\u0627\u062A \u0633\u0641\u0631"}</div></div><div className="relative p-4">{SNAPP_IR_LIST.map(item_0 => {
            const isActive = selectedService === item_0;
            return <div aria-hidden={!isActive} className={`flex flex-col ${isActive ? "relative" : "pointer-events-none invisible absolute inset-0 opacity-0"}`} key={item_0.title}>{item_0.subLinks?.map(_temp2)}</div>;
          })}</div></div></div>;
    $[11] = closeDrawer;
    $[12] = selectedService;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== drawerIsOpen || $[15] !== t6) {
    t7 = <Transition in={drawerIsOpen} mountOnEnter={true} timeout={75} unmountOnExit={true}>{t6}</Transition>;
    $[14] = drawerIsOpen;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <>{t5}{t7}</>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp2(item_1) {
  return <a className="text-subtitle-1 text-on-surface-high-emphasis border-outline-thin inline-block truncate whitespace-nowrap border-b px-4 py-5" href={item_1.url}>{item_1.name}</a>;
}
function _temp() {
  return document.body.classList.remove("prevent-scroll");
}